import { ApiService } from "src/network/apiService";
import { IApiResponse } from "src/network/models/ApiResponse";
import { IAccountModel } from "../account-management/account-management-view-model";

export class AccountViewModel {
    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }

    async setSessionAsync(accountId: string): Promise<boolean> {
        const URL = `/onboard/user-session`

        const body = {
            accountId: accountId
        }

        const response = await this.apiService.postAsync<IApiResponse<any>, any>(URL, body);

        if (response.scResponse.code === 2000) {
            return true;
        }

        return false
    }

    async getAccountsAsync(): Promise<IAccountModel[]> {
        const URL = `/onboard/accounts`
        const response = await this.apiService.getAsync<IApiResponse<IAccountModel[]>>(URL);

        if (response.scResponse.code === 2000) {
            return response.scResponse.data;
        }

        return [];
    }

    async getAccountAsync(): Promise<IAccountModel | undefined> {
        const URL = `/onboard/account`
        const response = await this.apiService.getAsync<IApiResponse<IAccountModel>>(URL);

        if (response.scResponse.code === 2000) {
            return response.scResponse.data;
        }

        return undefined;
    }
}